import { jsxs as E, jsx as s } from "react/jsx-runtime";
import { useRef as L, useCallback as j, useEffect as C, forwardRef as M } from "react";
import { L as P } from "../index-D6IbTb4M.js";
import { c as W } from "../clsx-OuTLNxxd.js";
import { B as x } from "../Button-DhycXY8d.js";
import '../Dialog.css';const X = "_closeButton_1ubah_32", Y = "_dialog_1ubah_36", $ = "_hasBackdrop_1ubah_52", z = "_isFullScreen_1ubah_55", q = "_closeButtonWrapper_1ubah_64", A = "_dialogWrapper_1ubah_77", G = "_panel_1ubah_91", a = {
  closeButton: X,
  dialog: Y,
  hasBackdrop: $,
  isFullScreen: z,
  closeButtonWrapper: q,
  dialogWrapper: A,
  panel: G
}, N = ({
  children: t,
  className: r,
  hasBackdrop: n = !0,
  isFullScreen: w = !1,
  isOpen: e = !1,
  setIsOpen: i,
  shouldCloseOnClickOutside: d = !0,
  title: p,
  triggerRef: l,
  ...y
}) => {
  const c = L(null), u = j(
    (o) => {
      var b, k, g;
      if (!d)
        return;
      const D = (b = c.current) == null ? void 0 : b.getBoundingClientRect(), { bottom: m = 0, left: h = 0, right: _ = 0, top: f = 0 } = D || {};
      if (f === 0 && m === 0 && h === 0 && _ === 0)
        return;
      const F = o.clientY < f || o.clientY > m || o.clientX < h || o.clientX > _, B = ((k = l == null ? void 0 : l.current) == null ? void 0 : k.isConnected) ?? !1, S = B && ((g = l == null ? void 0 : l.current) == null ? void 0 : g.contains(o == null ? void 0 : o.target)), T = o.target === c.current;
      e && (T || F && !S && B) && i(!1);
    },
    [e, d, i, l]
  );
  return C(() => {
    c.current && (e ? c.current.showModal() : c.current.close());
  }, [c, e]), C(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", u), () => {
        document.removeEventListener("click", u);
      };
  }, [u]), /* @__PURE__ */ E(
    "dialog",
    {
      "aria-label": `${p}-modal`,
      className: W(
        a.dialog,
        { [a.hasBackdrop]: n },
        { [a.isFullScreen]: w },
        r
      ),
      "data-cxy-name": "dialog",
      id: "cxy-dialog",
      ref: c,
      ...y,
      children: [
        /* @__PURE__ */ s("div", { className: a.closeButtonWrapper, children: /* @__PURE__ */ s(
          x,
          {
            "aria-label": `Close ${p} Modal`,
            className: a.closeButton,
            "data-testid": "close-button",
            onClick: () => i(!1),
            variant: "ghost",
            children: /* @__PURE__ */ s(P, { size: "md" })
          }
        ) }),
        /* @__PURE__ */ s("div", { className: a.dialogWrapper, children: t })
      ]
    }
  );
}, H = ({ children: t, className: r, ...n }) => /* @__PURE__ */ s("section", { className: W(a.panel, r), ...n, children: /* @__PURE__ */ s("div", { className: a.panelWrapper, children: t }) }), J = M(({ children: t, ...r }, n) => /* @__PURE__ */ s(x, { ref: n, variant: "ghost", ...r, children: t }));
N.Panel = H;
N.Trigger = J;
export {
  N as Dialog
};
